if (!customElements.get('popup-signup')) {
  customElements.define(
    'popup-signup',
    class PopupSignup extends HTMLElement {
      constructor() {
        super();
        this.storageKey = `popup-signup:${this.id}`;
        this.delay = Number(this.dataset.delay) || 0;
        this.frequency = Number(this.dataset.frequency) || 0;
        this.klaviyoFormIds = (this.dataset.klaviyoFormIds || '').split(',').filter(Boolean);

        this.querySelector('[id^="PopupSignupClose-"]').addEventListener('click', () => this.dismiss());
        this.addEventListener('click', (event) => {
          if (event.target === this) this.dismiss();
        });
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.dismiss();
        });
        window.addEventListener('klaviyoForms', (event) => {
          const { type, formId } = event.detail || {};
          if (type === 'submit' && this.klaviyoFormIds.includes(String(formId))) this.dismiss();
        });

        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.section) this.show();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.dataset.section) this.hide();
        });
      }

      connectedCallback() {
        const section = this.closest('.shopify-section');
        if (section) this.dataset.section = section.id.replace('shopify-section-', '');

        if (window.Shopify && Shopify.designMode) return;
        if (this.recentlyDismissed()) return;
        this.timer = window.setTimeout(() => this.show(), this.delay);
      }

      recentlyDismissed() {
        const lastDismissed = Number(window.localStorage.getItem(this.storageKey));
        if (!lastDismissed) return false;
        return Date.now() - lastDismissed < this.frequency;
      }

      show() {
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        trapFocus(this, this.querySelector('[role="dialog"]'));
      }

      hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus();
      }

      dismiss() {
        window.clearTimeout(this.timer);
        window.localStorage.setItem(this.storageKey, Date.now());
        this.hide();
      }
    }
  );
}
